export { setupTitleTransitionCoordinator } from './coordinator.ts'
export type { TitleTransitionCoordinator } from './coordinator.ts'
export {
  beginPostTitleTransition,
  playPostTitleExitAnimation,
  preloadPostTitleTransition,
  renderPostTitleTransitionTarget,
  resolvePostTitleTransitionTarget,
} from './postTitleTransition.ts'
export type {
  PostTitleTransitionPreparation,
  ResolvePostTitleTransitionTargetOptions,
} from './types.ts'
